module.exports = __webpack_public_path__ + "static/icon_postmates-7027c338288f783cc05997bb7af944e0.png";